<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="查看单位"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        label-width="70px"
      >
			<el-form-item label="单位名称：">
			  <el-input
			    size="mini"
			    v-model.trim="form.unitName"
			    clearable
          disabled
			  ></el-input>
			</el-form-item>
				<el-form-item label="社会信用代码：" class="mr0 label-with-six-word" label-width="98px">
				  <el-input
          disabled
				    size="mini"
				    v-model.trim="form.creditCode"
				    clearable
				  ></el-input>
				</el-form-item>
        <el-form-item label="联系人：">
          <el-input
            size="mini"
            disabled
            v-model.trim="form.contactsName"
            clearable
          ></el-input>
        </el-form-item>
				<el-form-item label="联系电话：" class="mr0">
				  <el-input
				    size="mini"
				    v-model.trim="form.contactsPhone"
				    clearable
            disabled
				  ></el-input>
				</el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      form: {
        contactsPhone: '',
        contactsName: '',
        creditCode: '',
        unitName: ''
      }
    }
  },
  props: {
    editData: {
      type: Object,
      required: true
    }
  },
  created() {
    this.form = { ...this.editData }
  },
  methods: {
    handleBeforeClose(done) {
      this.$emit('cancel')
      done()
    },
    handleCancel() {
      this.$emit('cancel')
    },
    async handleConfirm() {
      this.$emit('cancel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/salesManagement/xmgl/components/CheckProject.vue